import { create } from 'apisauce'
import store from '../store'
import handleNetworkError from '../actions/network'
import { AUTHORIZATION_KEY, getSSOEndpoint } from '../utils/apiConstants'

const baseURL = `${getSSOEndpoint()}/auth/realms/azship/protocol/openid-connect`

const apiAuth = create({
  baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: AUTHORIZATION_KEY,
  },
})

apiAuth.axiosInstance.interceptors.response.use(
  (response) => {
    return response
  }, error => (
    new Promise(() => {
      if (error.response) {
        store.dispatch(handleNetworkError(error.response.status, error.response.data))
      } else {
        store.dispatch(handleNetworkError(0))
      }
    })
  ))

apiAuth.addRequestTransform((request) => {
})

export default apiAuth
